import { RagApiClient } from '@/services/ApiService'

export interface ComercialPhoneBinding {
  id: string
  phone: string
  id_comercial: string
  display_name: string
  is_active: boolean
  /** La puso la siembra desde el censo; al editarla pasa a false y deja de pisarse. */
  seeded_from_census: boolean
}

export interface NewComercialPhoneBinding {
  phone: string
  id_comercial: string
  display_name?: string
}

export interface SeedReport {
  dry_run: boolean
  creados: number
  actualizados: number
  respetados: number
  /** Teléfonos que figuran en dos comerciales; no se declaran solos. */
  ambiguos: { telefono: string; comerciales: string[] }[]
}

type Envelope<T> = { success: boolean; data: T }
type ListData = { items: ComercialPhoneBinding[]; count: number }

const BINDINGS_BASE = '/api/agent/v1/comerciales/bindings'

const bindingsApi = new RagApiClient()

class ComercialPhoneBindingsServiceClient {
  async list(): Promise<ComercialPhoneBinding[]> {
    const response = await bindingsApi.get(`${BINDINGS_BASE}/`) as Envelope<ListData>
    return response?.data?.items ?? []
  }

  async create(payload: NewComercialPhoneBinding): Promise<ComercialPhoneBinding> {
    const response = await bindingsApi.post(`${BINDINGS_BASE}/`, payload) as Envelope<ComercialPhoneBinding>
    return response.data
  }

  async update(
    id: string,
    changes: Partial<Pick<ComercialPhoneBinding, 'id_comercial' | 'display_name' | 'is_active'>>
  ): Promise<ComercialPhoneBinding> {
    const response = await bindingsApi.patch(`${BINDINGS_BASE}/${id}/`, changes) as Envelope<ComercialPhoneBinding>
    return response.data
  }

  /** Trae del censo los teléfonos que iagestión ya conoce. No pisa lo editado a mano. */
  async seed(dryRun = false): Promise<SeedReport> {
    const response = await bindingsApi.post(`${BINDINGS_BASE}/seed/`, {
      dry_run: dryRun,
    }) as Envelope<SeedReport>
    return response.data
  }

  async remove(id: string): Promise<void> {
    await bindingsApi.delete(`${BINDINGS_BASE}/${id}/`)
  }
}

export const comercialPhoneBindingsService = new ComercialPhoneBindingsServiceClient()
